export enum ProfileType {
  master = 'MASTER',
  masterBo = 'MASTER_BO',
  clientBo = 'ClientBO',
  operator = "OPERATOR",
  OperatorBo="OPERATOR_BO"
}

export enum PermissionsType {
  master = 'Master',
  masterBo = 'Master BO',
  excluirPerfilDeAcesso = 'Excluir perfil de acesso',
  cadastrarUsuario = 'Cadastrar usuário',
  cadastrarUsuarios = 'Cadastrar usuários',
  editarUsuarios = 'Editar usuários',
  consulta = 'Consulta',
  consultaGeral = 'Consulta Geral',
  consultaComMedida = 'Consulta com Medida',
  consultaSemMedida = 'Consulta sem Medida',
  consultaTudo = 'Consulta Tudo',
  permissaoDeConsultarTudo = 'Permissão de Consultar Tudo',
  dashRelatorioDeTudoParaOChefe = 'Dash - Relatório de Tudo para o Chefe',
  acessarDashboard = 'Acessar dashboard',
  consultarFundos = 'Consultar fundos',
  editarFundo = 'Editar fundo',
  consultarGruposDeInvestimentos = 'Consultar grupos de investimentos',
  definirPerfilDeAcesso = 'Definir perfil de acesso',
  dashCotasDoFundo = 'Dash - Cotas do Fundo',
  criarPerfilDeAcesso = 'Criar Perfil de acesso',
  editarPerfilDeAcesso = 'Editar perfil de acesso',
  dashCaixaOnLine = 'Dash - Caixa on line',
  dashOperacoes = 'Dash - Operações',
  dashCotas = 'Dash - Cotas',
  dashPL = 'Dash - PL',
  dashFluxoDeCaixaDoFundo = 'Dash - Fluxo de caixa do fundo',
  dashPLDoFundo = 'Dash - PL do fundo',
  dashOperacoesdoFundo = 'Dash - Operações do fundo',
  compromissada = 'Compromissada',
  cadastroDeOpcoesFlexiveis = 'Cadastro de opções Flexiveis',
  despesasReceitas = 'Despesas/Receitas',
  bloqueioDesbloqueioFiduciario = 'Bloqueio/Desbloqueio Fiduciário',
  notas = 'Notas',
  dashNotas = 'Dash - Notas',
  dashAprovarCotasDoFundo = 'Dash - Aprovar Cotas do Fundo',
  dashRejeitarCotasDoFundo = 'Dash - Rejeitar Cotas do Fundo',
  dashInfoDoFundo = 'Dash - Informações do Fundo',
  dashAcumuladoGestao = 'Dash - Acumulado Gestão',
  dashInsumosPendentes = 'Dash - Insumos Pendentes',
  criarGrupoDeInvestimentos = 'Criar grupo de investimento',
  editarGrupoDeInvestimentos = 'Editar grupo de investimento',
  operacoesBoletagemManual = "Operações - Boletagem Manual",
  boletagemManualRendaVariavel = "Boletagem Manual - Renda variável",
  ativosOperacoes = "Ativos - Operações",
  Consultar_Boleta_de_Renda_Variável = "Consultar Boleta de Renda Variável",
  Autorizar_Boleta_de_Renda_Variável = "Autorizar Boleta de Renda Variável",
  Excluir_Boleta_de_Renda_Variável = "Excluir Boleta de Renda Variável",
  Editar_Boleta_de_Renda_Variável = "Editar Boleta de Renda Variável",
  Cadastrar_Boleta_de_Renda_Variável = "Cadastrar Boleta de Renda Variável",
  Cancelar_Boleta_de_Renda_Variável = "Cancelar Boleta de Renda Variável",
  Consultar_Boleta_de_Renda_Fixa = "Consultar Boleta de Renda Fixa",
  Autorizar_Boleta_de_Renda_Fixa = "Autorizar Boleta de Renda Fixa",
  RejeitarExcluir_Boleta_de_Renda_Fixa = "Excluir Boleta de Renda Fixa",
  Editar_Boleta_de_Renda_Fixa = "Editar Boleta de Renda Fixa",
  Cadastrar_Boleta_de_Renda_Fixa = "Cadastrar Boleta de Renda Fixa",
  Cancelar_Boleta_de_Renda_Fixa = "Cancelar Boleta de Renda Fixa",
  Consultar_Boleta_de_Futuros = "Consultar Boleta de Futuros",
  Autorizar_Boleta_de_Futuros = "Autorizar Boleta de Futuros",
  RejeitarExcluir_Boleta_de_Futuros = "Excluir Boleta de Futuros",
  Editar_Boleta_de_Renda_Futuros = "Editar Boleta de Futuros",
  Cadastrar_Boleta_de_Futuros = "Cadastrar Boleta de Futuros",
  Cancelar_Boleta_de_Futuros = "Cancelar Boleta de Futuros",
  Consultar_Boleta_de_Cotas_de_Fundos = "Consultar Boleta de Cotas de Fundos",
  Autorizar_Boleta_de_Cotas_de_Fundos = "Autorizar Boleta de Cotas de Fundos",
  RejeitarExcluir_Boleta_de_Cotas_de_Fundos = "Excluir Boleta de Cotas de Fundos",
  Editar_Boleta_de_Renda_Cotas_de_Fundos = "Editar Boleta de Cotas de Fundos",
  Cadastrar_Boleta_de_Cotas_de_Fundos = "Cadastrar Boleta de Cotas de Fundos",
  Cancelar_Boleta_de_Cotas_de_Fundos = "Cancelar Boleta de Cotas de Fundos",
  Consultar_Boleta_de_Bloqueio_Desbloqueio_de_Fundos = "Consultar Boleta de Bloqueio/Desbloqueio de Fundos",
  Autorizar_Boleta_de_Bloqueio_Desbloqueio_de_Fundos = "Autorizar Boleta de Bloqueio/Desbloqueio de Fundos",
  RejeitarExcluir_Boleta_de_Bloqueio_Desbloqueio_de_Fundos = "Excluir Boleta de Bloqueio/Desbloqueio de Fundos",
  Editar_Boleta_de_Renda_Bloqueio_Desbloqueio_de_Fundos = "Editar Boleta de Bloqueio/Desbloqueio de Fundos",
  Cadastrar_Boleta_de_Bloqueio_Desbloqueio_de_Fundos = "Cadastrar Boleta de Bloqueio/Desbloqueio de Fundos",
  Cancelar_Boleta_de_Bloqueio_Desbloqueio_de_Fundos = "Cancelar Boleta de Bloqueio/Desbloqueio de Fundos",
  Consultar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Variável = "Consultar Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Autorizar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Variável = "Autorizar Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Excluir_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Variável = "Excluir Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Editar_Boleta_de_Renda_Bloqueio_Desbloqueio_de_Fundo_Renda_Variável = "Editar Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Cadastrar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Variável = "Cadastrar Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Cancelar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Variável = "Cancelar Boleta de Bloqueio/Desbloqueio de Renda Variável",
  Consultar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Fixa = "Consultar Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  Autorizar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Fixa = "Autorizar Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  RejeitarExcluir_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Fixa = "Excluir Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  Editar_Boleta_de_Renda_Bloqueio_Desbloqueio_de_Fundo_Renda_Fixa = "Editar Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  Cadastrar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Fixa = "Cadastrar Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  Cancelar_Boleta_de_Bloqueio_Desbloqueio_de_Renda_Fixa = "Cancelar Boleta de Bloqueio/Desbloqueio de Renda Fixa",
  Parâmetro_de_Grade_Horária = "Parâmetro de Grade Horária",
  Editar_Parâmetro_de_Grade_Horária = "Editar Parâmetro de Grade Horária",
  Parâmetro_de_Autorização_extra = "Parâmetro de Autorização extra",
  Criar_Parâmetro_de_Autorização_extra = "Criar Parâmetro de Autorização extra",
  Criar_Parâmetro_de_Autorização_Boleta_retroativa = "Criar Parâmetro de Autorização Boleta retroativa",
  Editar_Parâmetro_de_Autorização_extra = "Editar Parâmetro de Autorização extra",
  Excluir_Parâmetro_de_Autorização = "Excluir Parâmetro de Autorização extra",
  Parâmetro_Feito_Conferido = "Parâmetro Feito/Conferido",
  Consultar_Boleta_de_Compromissada = "Consultar Boleta de Compromissada",
  Autorizar_Boleta_de_Compromissada = "Autorizar Boleta de Compromissada",
  Excluir_Boleta_de_Compromissada = "Excluir Boleta de Compromissada",
  Cadastrar_Boleta_de_Compromissada = "Cadastrar Boleta de Compromissada",
  Editar_Boleta_de_Compromissada = "Editar Boleta de Compromissada",
  Cancelar_Boleta_de_Compromissada = "Cancelar Boleta de Compromissada",
  Cadastrar_Boleta_de_Empréstimo_de_ações = "Cadastrar Boleta de Empréstimo de ações",
  Empréstimo_Boleta_de_Termo_de_ações = "Empréstimo de ações",
  Editar_Boleta_de_Empréstimo_de_ações = "Editar Boleta de Empréstimo de ações",
  Autorizar_Boleta_de_Empréstimo_de_ações = "Autorizar Boleta de Empréstimo de ações",
  Excluir_Boleta_de_Empréstimo_de_ações = "Excluir Boleta de Empréstimo de ações",
  Rejeitar_Boleta_de_Empréstimo_de_ações = "Rejeitar Boleta de Empréstimo de ações",
  Cancelar_Boleta_de_Empréstimo_de_ações = "Cancelar Boleta de Empréstimo de ações",
  Consultar_Boleta_de_Empréstimo_de_ações = "Consultar Boleta de Empréstimo de ações",
  Consultar_Boleta_de_Swap = "Consultar Boleta de Swap",
  Cadastrar_Boleta_de_Swap = "Cadastrar Boleta de Swap",
  Editar_Boleta_de_Swap = "Editar Boleta de Swap",
  Autorizar_Boleta_de_Swap = "Autorizar Boleta de Swap",
  Excluir_Boleta_de_Swap = "Excluir Boleta de Swap",
  Cancelar_Boleta_de_Swap = "Cancelar Boleta de Swap",
  Consultar_Boleta_de_Exercício_de_opções_de_Futuros = "Consultar Boleta de Exercício de opções de Futuros",
  Cadastrar_Boleta_de_Exercício_de_opções_de_Futuros = "Cadastrar Boleta de Exercício de opções de Futuros",
  Editar_Boleta_de_Exercício_de_opções_de_Futuros = "Editar Boleta de Exercício de opções de Futuros",
  Autorizar_Boleta_de_Exercício_de_opções_de_Futuros = "Autorizar Boleta de Exercício de opções de Futuros",
  Excluir_Boleta_de_Exercício_de_opções_de_Futuros = "Excluir Boleta de Exercício de opções de Futuros",
  Cancelar_Boleta_de_Exercício_de_opções_de_Futuros = "Cancelar Boleta de Exercício de opções de Futuros",
  Cadastrar_Boleta_de_Exercício_de_opções_Renda_Variável = "Cadastrar Boleta de Exercício de Opções de Renda Variável",
  Editar_Boleta_de_Exercício_de_opções_de_Renda_Variável = "Editar Boleta de Exercício de Opções de Renda Variável",
  Autorizar_Boleta_de_Exercício_de_Opçõe_de_Renda_Variável = "Autorizar Boleta de Exercício de Opções de Renda Variável",
  Excluir_Boleta_de_Exercício_de_Opções_de_Renda_Variável = "Excluir Boleta de Exercício de Opções de Renda Variável",
  Consultar_Boleta_de_Exercício_de_Opções_de_Renda_Variável = "Consultar Boleta de Exercício de Opções de Renda Variável",
  Cancelar_Boleta_de_Exercício_de_Opções_de_Renda_Variável = "Cancelar Boleta de Exercício de Opções de Renda Variável",
  Cadastrar_Boleta_de_Despesas_e_Receitas = "Cadastrar Boleta de Despesas e Receitas",
  Editar_Boleta_de_Despesas_e_Receitas = "Editar Boleta de Despesas e Receitas",
  Autorizar_Boleta_de_Despesas_e_Receitas = "Autorizar Boleta de Despesas e Receitas",
  Excluir_Boleta_de_Despesas_e_Receitas = "Excluir Boleta de Despesas e Receitas",
  Consultar_Boleta_de_Despesas_e_Receitas = "Consultar Boleta de Despesas e Receitas",
  Cancelar_Boleta_de_Despesas_e_Receitas = "Cancelar Boleta de Despesas e Receitas",
  Cadastrar_Boleta_de_Ingresso_e_Retirada = "Cadastrar Boleta de Ingresso e Retirada",
  Editar_Boleta_de_Ingresso_e_Retirada = "Editar Boleta de Ingresso e Retirada",
  Autorizar_Boleta_de_Ingresso_e_Retirada = "Autorizar Boleta de Ingresso e Retirada",
  Excluir_Boleta_de_Ingresso_e_Retirada = "Excluir Boleta de Ingresso e Retirada",
  Consultar_Boleta_de_Ingresso_e_Retirada = "Consultar Boleta de Ingresso e Retirada",
  Cancelar_Boleta_de_Ingresso_e_Retirada = "Cancelar Boleta de Ingresso e Retirada",
  Editar_Boleta_de_Termo_de_ações = "Editar Boleta de Termo de ações",
  Autorizar_Boleta_de_Termo_de_ações = "Autorizar Boleta de Termo de ações",
  Excluir_Boleta_de_Termo_de_ações = "Excluir Boleta de Termo de ações",
  Consultar_Boleta_de_Termo_de_ações = "Consultar Boleta de Termo de ações",
  Cancelar_Boleta_de_Termo_de_ações = "Cancelar Boleta de Termo de ações",
  Cadastrar_Boleta_de_Termo_de_ações = "Cadastrar Boleta de Termo de ações",
  Editar_Boleta_de_Câmbio = "Editar Boleta de Câmbio",
  Autorizar_Boleta_de_Câmbio = "Autorizar Boleta de Câmbio",
  Excluir_Boleta_de_Câmbio = "Excluir Boleta de Câmbio",
  Consultar_Boleta_de_Câmbio = "Consultar Boleta de Câmbio",
  Cancelar_Boleta_de_Câmbio = "Cancelar Boleta de Câmbio",
  Cadastrar_Boleta_de_Câmbio = "Cadastrar Boleta de Câmbio",
  Consultar_Upload_de_Boletas = "Consultar Upload de Boletas",
  Novo_Upload_de_Boletas = "Upload",
  Baixar_Layouts = "Baixar Lay-outs",
  access_Ativo_santanderOper='Acessar Ativos em Santander Oper',
  access_passivo_santanderOper='Acessar Passivos em Santander Oper',
  posicao_RF_Operation_Blocking_Per_mvnt='POSICAO - Fixed Income Operation Blocking  Per movement',
  posicao_OtherValues='POSICAO - OtherValues',
  posicao_Blocked_Position_Fund_Quotas='POSICAO - Blocked Position of Fund Quotas',
  posicao_SWAP_Calculation_Memory='POSICAO - SWAP Calculation Memory',
  posicao_Cash_flow='POSICAO - Cash flow',
  posicao_Detailed_Fixed_Income_Stock='POSICAO - Detailed Fixed Income Stock',
  posicao_Daily_Portfolio='POSICAO - Daily Portfolio',
  posicao_Temporary_Movement='POSITION - TEMPORARY MOVEMENT',
  posicao_Stock_Loan_Position='POSICAO - Stock Loan Position',
  posicao_Futures_Position='POSICAO - Futures Position',
  posicao_SWAP_position='POSICAO - SWAP position',
  posicao_Bocked_Position_of_Variable_Incomes='POSICAO - Bocked Position of Variable Incomes',
  posicao_Composition_of_the_Fund_Portfolio='POSICAO - Composition of the Fund Portfolio',
  movement_Quota_Evolution_Map='MOVEMENT - Quota Evolution Map',
  movement_cash_statement='MOVEMENT - cash statement',
  movement_Dividends_Interest='MOVEMENT - Dividends Interest',
  movement_Movement_of_Term_Shares='MOVEMENT - Movement of Term Shares',
  movement_Movement_of_Stock_Loans='MOVEMENT - Movement of Stock Loans',
  movement_Movement_of_Futures='MOVEMENT - Movement of Futures',
  movement_Movement_of_Deposit_Withdrawal='MOVEMENT - Movement of Deposit / Withdrawal',
  movement_SWAP_movement='MOVEMENT - SWAP movement',
  movement_Fixed_Income_Settlement_Note='MOVEMENT - Fixed Income Settlement Note',
  movement_Blocking_Variable_Incomes_Operations='MOVEMENT - Blocking Variable Incomes Operations',
  movement_Investment_Fund_Operations='MOVEMENT - Investment Fund Operations',
  movement_Fixed_IncomeS_Fixed_Income_Securities_Operationsecurities_Operations='MOVEMENT - Fixed IncomeS Fixed Income Securities Operationsecurities Operations',
  movement_Variable_Income_Operations='MOVEMENT - Variable Income Operations',
  other_Book_SAC='OTHER - Book SAC',
  other_Book_SAT='OTHER - Book SAT',
  Consultar_Boleta_de_Compromissada_SAM = "Consultar Boleta de Compromissada SAM",
  Autorizar_Boleta_de_Compromissada_SAM = "Autorizar Boleta de Compromissada SAM",
  Excluir_Boleta_de_Compromissada_SAM = "Excluir Boleta de Compromissada SAM",
  Cadastrar_Boleta_de_Compromissada_SAM = "Cadastrar Boleta de Compromissada SAM",
  Editar_Boleta_de_Compromissada_SAM = "Editar Boleta de Compromissada SAM",
  Cancelar_Boleta_de_Compromissada_SAM = "Cancelar Boleta de Compromissada SAM",
  compromissada_SAM = 'Compromissada SAM',
  other_Book_SAT_SAM='OTHER - Book SAT SAM',
  CONSULT_REQUESTS='Consult_Requests'
}

export const AllPermissionsTypes = Object.keys(PermissionsType).map(key => {
  return {
    typePermission: 'Permissões de sistema',
    namePermission: PermissionsType[key],
  };
});

export enum PermissionKind {
  sistema = 'Permissões de sistema',
  operacao = 'Permissões de operação',
  relatorio = 'Permissões de relatório'
}
